<template>
  <div>
    <div class="mb-1">
      <small class="ml-1 text-muted"> {{$t('contact.comment')}}: </small>
    </div>
    <VuePerfectScrollbar
      class="scroll"
      :settings="settings"
      @ps-y-reach-start="fetchComment"
      ref="comment"
    >
      <div v-if="loading" class="d-flex justify-content-center py-1">
        <BSpinner />
      </div>
      <div class="overflow-hidden p-50">
        <app-timeline>
          <template v-for="comment in GET_PTO_FOR_GOOD_ONE.comments">
            <CommentsItem
              @openFilePreview="openFilePreview"
              :key="comment.id"
              @deleteComment="deleteComment"
              @replyComment="(data) => (replyComment = data)"
              :comment="comment"
              line
            />
          </template>
        </app-timeline>
      </div>
    </VuePerfectScrollbar>

    <div>
      <!-- <div v-if="replyComment">
        <hr />
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex">
            <div class="pr-1 pt-25">
              <feather-icon icon="CornerUpLeftIcon" size="30" />
            </div>
            <div>
              <b-link href="#">{{ "Ali" }}</b-link>
              <p>{{ replyComment.message }}</p>
            </div>
          </div>

          <div>
            <feather-icon
              icon="XIcon"
              class="cursor-pointer"
              size="20"
              @click="replyComment = null"
            />
          </div>
        </div>
      </div> -->

      <b-form-textarea
        v-model="inputValue"
        :placeholder="$t('write_comments') + '...'"
      >
      </b-form-textarea>

      <div class="d-flex justify-content-end pt-50">
        <!-- <b-button
          class="mr-50"
          variant="warning"
          size="sm"
          v-b-modal.upload-modal
          >Прикрепить файл</b-button
        > -->

        <b-button
          size="sm"
          variant="primary"
          :disabled="!inputValue.trim()"
          @click="addComment"
        >
          {{$t('leave_a_comment')}}
        </b-button>
      </div>
    </div>

    <!-- <PreviewFile :src="src" /> -->
  </div>
</template>

<script>
import {
  BAvatar,
  BLink,
  BButton,
  BListGroup,
  BAvatarGroup,
  BBadge,
  BFormTextarea,
  BSpinner,
} from "bootstrap-vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { getUserData } from "@/auth/utils";
import CommentsItem from "./CommentsItem.vue";
import moment from "moment";
import PreviewFile from "../PreviewFile.vue";

export default {
  props: {
    // content_type: {
    //   type: [Number, String],
    //   required: true,
    // },
    object_id: {
      type: [Number, String],
      required: true,
    },
    // settings: {
    //   type: Object,
    //   required: false,
    //   default() {
    //     return {
    //       maxScrollbarLength: 60,
    //     };
    //   },
    // },
  },
  data() {
    return {
      loading: false,
      inputValue: "",
      replyComment: null,
      src: "",
      settings: {
        maxScrollbarLength: 70,
      },
    };
  },
  methods: {
    ...mapActions("comments", [
      "ADD_COMMENT",
      "FETCH_COMMENTS",
      "DELETE_COMMENT",
    ]),

    ...mapActions("pto", ["UPDATE_PTO_FOR_GOOD", "FETCH_PTO_FOR_GOOD_ONE"]),
    ...mapMutations("comments", ["CLEAR_COMMENTS"]),
    openFilePreview(src) {
      this.src = src;
      this.$nextTick(() => {
        this.$bvModal.show("preview-file-modal");
      });
    },
    async fetchComment() {
      // if (this.loading) {
      //   return;
      // }
      // if (this.getComments.next) {
      //   this.loading = true;
      //   await this.FETCH_COMMENTS({
      //     offset: this.getComments.results.length,
      //   });
      //   this.$nextTick(() => {
      //     if (this.$refs.comment.$el) {
      //       this.$refs.comment.$el.scrollTop = 1000;
      //     }
      //   });
      //   this.loading = false;
      // }
    },
    async addComment() {
      if (!this.inputValue.trim()) {
        return (this.inputValue = "");
      }
      try {
        const message = {
          id: this.object_id,
          comment: this.inputValue,
        };
        // if (this.replyComment) {
        //   message.parent = this.replyComment.id;
        // }
        await this.UPDATE_PTO_FOR_GOOD(message);
        await this.FETCH_PTO_FOR_GOOD_ONE(this.object_id);
        this.$emit('refresh')

        this.inputValue = "";

        // if (!this.replyComment) {
        //   this.scrollBottom();
        // }

        // this.replyComment = null;

        this.$_okToast();
      } catch (err) {
        this.$_errToast('Error');
      }
    },
    async deleteComment(comment) {
      try {
        await this.DELETE_COMMENT(comment);

        this.$_okToast();

        if (this.replyComment && this.replyComment.id == comment.id) {
          this.replyComment = null;
        }

        if (this.getComments.results.length < 5) {
          this.fetchComment();
        }
      } catch (err) {
        this.$_errToast('Error');
      }
    },
    scrollBottom() {
      this.$nextTick(() => {
        if (this.$refs.comment.$el) {
          this.$refs.comment.$el.scrollTop =
            this.$refs.comment.$el.scrollHeight;
        }
      });
    },
    keyHandlerSubmit(event) {
      if (event.key === "\n") {
        this.addComment();
      }
    },
  },
  async mounted() {
    document.body.addEventListener("keypress", this.keyHandlerSubmit);

    moment.locale(this.$getLang);
    try {
      if (!this.getComments.results.length) {
        this.loading = true;

        await this.FETCH_COMMENTS({
          content_type: this.content_type,
          object_id: this.object_id,
        });

        this.loading = false;
      }
      this.scrollBottom();
    } catch (err) {
      console.log(err)
      // this.$_errToast('Error');
    }
  },
  computed: {
    // ...mapGetters("comments", ["getComments"]),
    ...mapGetters("pto", ["GET_PTO_FOR_GOOD_ONE"]),
  },

  destroyed() {
    this.CLEAR_COMMENTS();
    document.body.removeEventListener("keypress", this.keyHandlerSubmit);
  },
  components: {
    AppTimeline,
    VuePerfectScrollbar,
    CommentsItem,
    PreviewFile,
    BLink,
    BAvatar,
    BButton,
    BListGroup,
    BAvatarGroup,
    BBadge,
    BFormTextarea,
    BSpinner,
  },
};
</script>

<style scoped>
/* .scroll {
  max-height: 85vh;
} */

/* .comment {
  min-height: 25px;
  border-bottom: 2px solid lightgrey;
  outline: none !important;
} */

.scroll {
  height: 25vh;
}

.comment {
  max-width: 90%;
}
</style>
